import { useState, useEffect, useCallback } from 'react'
import api from '../api/client'
import { fmtFechaHora } from '../utils/fecha'
import Boton from '../components/Boton'
import Paginador from '../components/Paginador'

export default function LogActividadPage() {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [filtros, setFiltros] = useState({ q: '', accion: '', fecha_desde: '', fecha_hasta: '' })
  const [paginacion, setPaginacion] = useState({ current_page: 1, last_page: 1, total: 0 })
  const [page, setPage] = useState(1)

  const cargar = useCallback(async () => {
    setLoading(true)
    try {
      const params = { page, ...Object.fromEntries(Object.entries(filtros).filter(([, v]) => v)) }
      const { data } = await api.get('/logs-actividad', { params })
      setLogs(data.data)
      setPaginacion({ current_page: data.current_page, last_page: data.last_page, total: data.total })
    } catch { } finally { setLoading(false) }
  }, [filtros, page])

  useEffect(() => { cargar() }, [cargar])

  const setFiltro = (k) => (e) => { setFiltros(f => ({ ...f, [k]: e.target.value })); setPage(1) }

  return (
    <div>
      <div style={st.header}>
        <h2 style={st.title}>Log de Actividad</h2>
        <span style={st.badge}>{paginacion.total} registros</span>
      </div>

      <div style={st.filtros}>
        <input style={st.filtroInput} placeholder="Buscar acción, detalle, usuario..." value={filtros.q} onChange={setFiltro('q')} />
        <input style={st.filtroInput} placeholder="Acción exacta" value={filtros.accion} onChange={setFiltro('accion')} />
        <input style={st.filtroInput} type="date" value={filtros.fecha_desde} onChange={setFiltro('fecha_desde')} />
        <input style={st.filtroInput} type="date" value={filtros.fecha_hasta} onChange={setFiltro('fecha_hasta')} />
        <Boton variante="ghost" onClick={() => { setFiltros({ q: '', accion: '', fecha_desde: '', fecha_hasta: '' }); setPage(1) }}>Limpiar</Boton>
      </div>

      <div style={st.tableWrapper}>
        {loading ? (
          <p style={st.empty}>Cargando...</p>
        ) : logs.length === 0 ? (
          <p style={st.empty}>No hay registros.</p>
        ) : (
          <table style={st.table}>
            <thead>
              <tr>
                {['Fecha', 'Usuario', 'Acción', 'Entidad', 'Detalle', 'IP'].map(h => (
                  <th key={h} style={st.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {logs.map(log => (
                <tr key={log.id} style={st.tr}>
                  <td style={st.td}><span style={st.mono}>{fmtFechaHora(log.created_at)}</span></td>
                  <td style={st.td}>{log.usuario_nombre || <span style={st.na}>Sistema</span>}</td>
                  <td style={st.td}><span style={accionStyle(log.accion)}>{log.accion}</span></td>
                  <td style={st.td}>{log.entidad_tipo ? `${log.entidad_tipo} #${log.entidad_id}` : <span style={st.na}>—</span>}</td>
                  <td style={st.td}>{log.detalle || <span style={st.na}>—</span>}</td>
                  <td style={st.td}><span style={st.mono}>{log.ip || '—'}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <Paginador pagina={paginacion.current_page} totalPaginas={paginacion.last_page} onCambiar={setPage} />
    </div>
  )
}

function accionStyle(accion) {
  const base = { padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: '700' }
  if (accion === 'login') return { ...base, background: '#dcfce7', color: '#166534' }
  if (accion === 'logout') return { ...base, background: '#f1f5f9', color: '#475569' }
  if (accion?.includes('crear') || accion?.includes('alta')) return { ...base, background: '#dbeafe', color: '#1e40af' }
  if (accion?.includes('eliminar') || accion?.includes('frenar') || accion?.includes('anular')) return { ...base, background: '#fee2e2', color: '#991b1b' }
  return { ...base, background: '#fef3c7', color: '#92400e' }
}

const st = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' },
  title: { margin: 0, fontSize: '1.25rem', color: '#1e293b' },
  badge: { background: '#f1f5f9', color: '#475569', padding: '0.25rem 0.75rem', borderRadius: '20px', fontSize: '0.8125rem', fontWeight: '600' },
  filtros: { display: 'flex', gap: '0.75rem', marginBottom: '1rem', flexWrap: 'wrap' },
  filtroInput: { padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.875rem' },
  tableWrapper: { background: 'white', borderRadius: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', overflow: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { padding: '0.75rem 1rem', textAlign: 'left', background: '#f1f5f9', fontSize: '0.8125rem', fontWeight: '700', color: '#475569', borderBottom: '1px solid #e2e8f0', whiteSpace: 'nowrap' },
  tr: { borderBottom: '1px solid #f1f5f9' },
  td: { padding: '0.625rem 1rem', fontSize: '0.8125rem', color: '#334155' },
  mono: { fontFamily: 'monospace', fontSize: '0.8rem' },
  na: { color: '#cbd5e1' },
  empty: { padding: '2rem', textAlign: 'center', color: '#94a3b8' },
  paginacion: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', marginTop: '1rem', fontSize: '0.875rem' },
  pagBtn: { padding: '0.375rem 0.875rem', border: '1px solid #d1d5db', borderRadius: '6px', background: 'white', cursor: 'pointer' },
}
